/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { notificationControllerDelete } from '../fn/notification/notification-controller-delete';
import { NotificationControllerDelete$Params } from '../fn/notification/notification-controller-delete';
import { notificationControllerFindAll } from '../fn/notification/notification-controller-find-all';
import { NotificationControllerFindAll$Params } from '../fn/notification/notification-controller-find-all';
import { notificationControllerFindById } from '../fn/notification/notification-controller-find-by-id';
import { NotificationControllerFindById$Params } from '../fn/notification/notification-controller-find-by-id';
import { notificationControllerRead } from '../fn/notification/notification-controller-read';
import { NotificationControllerRead$Params } from '../fn/notification/notification-controller-read';
import { notificationControllerSearchCursor } from '../fn/notification/notification-controller-search-cursor';
import { NotificationControllerSearchCursor$Params } from '../fn/notification/notification-controller-search-cursor';
import { notificationControllerSearchOffset } from '../fn/notification/notification-controller-search-offset';
import { NotificationControllerSearchOffset$Params } from '../fn/notification/notification-controller-search-offset';
import { NotificationDto } from '../models/notification-dto';
import { NotificationOffsetPaginationDto } from '../models/notification-offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificationControllerFindAll()` */
  static readonly NotificationControllerFindAllPath = '/api/notification';

  /**
   * 알림 전체 조회.
   *
   * 알림 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerFindAll$Response(params?: NotificationControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NotificationDto>>> {
    return notificationControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 알림 전체 조회.
   *
   * 알림 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerFindAll(params?: NotificationControllerFindAll$Params, context?: HttpContext): Observable<Array<NotificationDto>> {
    return this.notificationControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NotificationDto>>): Array<NotificationDto> => r.body)
    );
  }

  /** Path part for operation `notificationControllerSearchOffset()` */
  static readonly NotificationControllerSearchOffsetPath = '/api/notification/search/offset';

  /**
   * 알림 오프셋 기반 조회.
   *
   * 알림을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSearchOffset$Response(params: NotificationControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationOffsetPaginationDto>> {
    return notificationControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 알림 오프셋 기반 조회.
   *
   * 알림을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSearchOffset(params: NotificationControllerSearchOffset$Params, context?: HttpContext): Observable<NotificationOffsetPaginationDto> {
    return this.notificationControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationOffsetPaginationDto>): NotificationOffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `notificationControllerSearchCursor()` */
  static readonly NotificationControllerSearchCursorPath = '/api/notification/search/cursor';

  /**
   * 알림 커서 기반 조회.
   *
   * 알림을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSearchCursor$Response(params: NotificationControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return notificationControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 알림 커서 기반 조회.
   *
   * 알림을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerSearchCursor(params: NotificationControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.notificationControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `notificationControllerFindById()` */
  static readonly NotificationControllerFindByIdPath = '/api/notification/{id}';

  /**
   * 알림 ID 기반 조회.
   *
   * 알림을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerFindById$Response(params: NotificationControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDto>> {
    return notificationControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 알림 ID 기반 조회.
   *
   * 알림을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerFindById(params: NotificationControllerFindById$Params, context?: HttpContext): Observable<NotificationDto> {
    return this.notificationControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationDto>): NotificationDto => r.body)
    );
  }

  /** Path part for operation `notificationControllerDelete()` */
  static readonly NotificationControllerDeletePath = '/api/notification/{id}';

  /**
   * 알림 삭제.
   *
   * 알림을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerDelete$Response(params: NotificationControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDto>> {
    return notificationControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 알림 삭제.
   *
   * 알림을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerDelete(params: NotificationControllerDelete$Params, context?: HttpContext): Observable<NotificationDto> {
    return this.notificationControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationDto>): NotificationDto => r.body)
    );
  }

  /** Path part for operation `notificationControllerRead()` */
  static readonly NotificationControllerReadPath = '/api/notification/read';

  /**
   * 모든 알림 읽음 처리.
   *
   * 모든 알림을 읽음 처리합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationControllerRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerRead$Response(params?: NotificationControllerRead$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return notificationControllerRead(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 알림 읽음 처리.
   *
   * 모든 알림을 읽음 처리합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationControllerRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationControllerRead(params?: NotificationControllerRead$Params, context?: HttpContext): Observable<boolean> {
    return this.notificationControllerRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
